import { useTranslation } from "react-i18next";
import lineIcon from './../../../assets/kudzu-plus-images/line-image.png';
import infoIcon from './../../../assets/kudzu-plus-images/Info.png';
import TickMarkIcon from './../../../assets/kudzu-plus-images/Tick-mark.png';
import kudzuSmall from './../../../assets/kudzu-plus-images/kudzu-small-logo.png';
import kudzuPlusSmall from './../../../assets/kudzu-plus-images/kudzu+_small-logo.png';
import { useNavigate } from "react-router";
import { addLineBreaks } from "../../../utils";
import logFirebaseEvents from "../../../components/LogFirebaseEvents";
import { appTheme, getUserMembership } from "../../../helpers/utils/Utils";
import { useSelector } from "react-redux";
import { PAID_PROMO_KEY } from "../../../network/URLConstants";
import { useState } from "react";
import Loader from "../../../components/CustomComponents/Loader";


const ComparisonOffer = ({handleComparisonScreen,defaultCornerRadius,btn1BrExist,btn1TextColor, preLoginAgreement}) => {  
    const SignUpKudzuplusTrue = useSelector(state => state.isSignUpKudzuplusTrueData);
    const isSignUpKudzuplusTrialVal = useSelector(state => state.isSignUpKudzuplusTrial);
    const documentAgreementType = useSelector(state => state.documentAgreementType);

    const [visibleTooltipIndex, setVisibleTooltipIndex] = useState(null);
    const cards = useSelector(state => JSON.parse(state.userCards));


  const toggleTooltip = (index) => {
    setVisibleTooltipIndex(visibleTooltipIndex === index ? null : index);
  };

    const [ toolTip,setToolTip ] = useState(true);
    const appThemeData = appTheme(SignUpKudzuplusTrue);  
    const { t } = useTranslation(); 
    const navigate = useNavigate()
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
    const [loading, setLoading] = useState(false)
    const accessTokenToApi = useSelector((state) => state.accessToken);
    const userMembershipData = getUserMembership(loggedResponse)

    
    const mapData = [
        { text: "2-Day Early Direct Deposit Access",id:"1", kudzuData: "", kudzuPlusData: "", toolTipMessage:addLineBreaks(t("toolTip_2Day")),toolTipStyle:"!w-[176px] left-[-66px]"},
        { text: "Covered by Kudzu+",id:"2", kudzuData: "", kudzuPlusData: "",toolTipMessage: <><span>{addLineBreaks(t("coveredbyKudzu_toolTip"))}</span> <span className="underline" onClick={() =>  handleClick()}>{t('here')}</span></>,toolTipStyle:" !w-[188px] left-[-70px]" },
        { text: "Savings Annual Percentage Yield (APY)",id:"3", kudzuData: ".75%", kudzuPlusData: "1.26%",toolTipMessage: addLineBreaks(t("annual_rate")),toolTipStyle:" !w-[189px] left-[-70px]" },
        { text: "Savings Goals",id:"", kudzuData: "", kudzuPlusData: "",toolTipMessage:addLineBreaks(t("savings_goals_toolTip")),toolTipStyle:"!w-[191px] left-[-70px]" },
        { text: "No out of network ATM Withdrawl Fees",id:"4",kudzuData: "", kudzuPlusData: "",toolTipMessage:addLineBreaks(t("with_draw")),toolTipStyle:"!w-[230px] left-[-86px]" }
    ];

    const handleClick = () => {
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
           preLoginAgreement();
        }
        else {
            navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
                url: "CoveredByKudzuPlusTerms",
             accType: 64, CardKey: cards?.[0]?.CardKey } });

        }
    }

    return (
        <div
            style={{
                borderRadius: defaultCornerRadius ? '1.5rem' : '0',
                padding: '0',
                width: '100%',
                maxWidth: '778px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            }}
            className="sm:rounded-tl-card-tr mt-10"
        >
            <div className="bg-gradient-to-r from-[#2965FB] to-[#30BC89] rounded-tr-[1.5rem] sm:p-4 p-6">
                <div className=" text-white font-hanken-grotesk md:p-3 p-0 gap-4 font-[600] md:px-6 flex justify-end xsm:gap-[2.5rem]  md:gap-[8.5rem] ">
                    <img src={kudzuSmall} alt="" />
                    <img src={kudzuPlusSmall} alt="" />
                </div>
            </div>
            <div className="bg-white sm:pl-6">

                {mapData && mapData.length > 0 && mapData.map((item, index) => (
                    <div key={index} className="flex justify-between items-center pl-6">

                        <div className={`flex items-center w-1/2 ${index === 0 ? 'pt-8' : ''} ${index === mapData.length - 1 ? 'pb-8' : ''}`}>
                            <p className="font-hanken-grotesk font-[600] text-[var(--text-clr-secondary3)] text-[14px]">{item.text}</p><span className="top-0 mt-[-13px] text-[8px] text-[#262B3A] font-semibold">{item.id}</span>
                            <div className="relative">
                                <img src={infoIcon} alt="infoIcon" className="ml-2 cursor-pointer" onClick={() => toggleTooltip(index)} />
                            {visibleTooltipIndex === index && (
                                <div
                                    className={`absolute font-hanken-grotesk font-[700] top-[34px]  p-[20px] bg-[#2965FB] text-white text-[12px] rounded-xl
              shadow-lg z-10 cursor-pointer transition-all duration-1000 ${item.toolTipStyle}`}
                                >
                                    <div className="tooltip-arrow-comparion font-hanken-grotesk text-[11px] "></div>
                                    {item.toolTipMessage}
                                </div>
                            )}
                            </div>
                        </div>
                        <div className={`flex items-center justify-center w-1/4 ${index === 0 ? 'pt-8' : ''} ${index === mapData.length - 1 ? 'pb-8' : ''}`}>
                            {item.kudzuData ? (
                                <p className="text-[#779CE5] md:text-[22px] sm:text-[16px] text-[18px] font-bold font-hanken-grotesk opacity-[60%]">{item.kudzuData}</p>
                            ) : <img src={lineIcon} alt="lineIcon" />}
                        </div>
                        <div className={`flex items-center justify-center sm:w-1/5 w-1/4 bg-[#A3D6E8] ${index === 0 ? 'pt-[52px] pb-[20px]' : ' py-[20px]'} ${index === mapData.length - 1 ? 'pb-[52px] pt-[20px]' : 'py-[20px]'}`}>
                            {item.kudzuPlusData ? (
                                <p className="text-[#2965FB] md:text-[22px] sm:text-[16px] text-[18px] font-bold font-hanken-grotesk">{item.kudzuPlusData}</p>
                            ) : <img src={TickMarkIcon} alt="tickMarkIcon" className="md:w-auto sm:w-8 w-5" />}
                        </div>
                    </div>
                ))}

            </div>
            <div className="flex justify-center bg-gradient-to-r from-[#2965FB] to-[#30BC89] p-6">
                <div className={`md:w-[454px] sm:w-[294px] xsm:w-[240px] w-[240px] flex flex-col justify-start gap-5`}>
                    <div className='lg:pt-15 md:pt-13 sm:pt-7 pt-6 w-full'>
                        <button
                            style={{ backgroundColor: 'white', borderRadius: btn1BrExist ? 50 : 0, color: '#2965FB' }}
                            className={`lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] w-full lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold leading-[16px] disabled:opacity-30 ${btn1TextColor === '#2965FB' && 'border-[#2965FB] border-[2.5px]'}   border-[2.5px] focus:border-[#2965FB] focus:border-[#3px]`}
                            tabIndex={0}
                            id='btn1AccRef'
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }}  
                            onClick={(event) => {
                                event.target.style.opacity = 0.8; logFirebaseEvents("Comparison", "Kudzu_Plus_Begin_Free_Trial_Clicked", "Kudzu_Plus_Begin_Free_Trial_Clicked", "", "");
                                if (handleComparisonScreen) { 
                                    handleComparisonScreen();
                                } else {
                                    navigate("/kudzuplusSecurity", { state: { type: t('upgrade_to_kduzu_plus') } });
                                }
                                setTimeout(() => { event.target.style.opacity = 1; }, 200);
                            }}  
                            >{(promoKey == PAID_PROMO_KEY ||loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true || 
                            userMembershipData?.extendTrial) ? t('Join_Kudzu+') : t("Begin_Free_3-Month_Trial")}</button>
                    </div>
                    <p className=" font-hanken-grotesk md:text-[11px]  text-[13px] font-[400] text-[white] w-[280px] sm:w-[316px] md:w-full">{promoKey === PAID_PROMO_KEY ? t('comparison_para_one') : (t("comparison_para_one"))}</p>
                    <p className="relative">
                        <div className="flex gap-0">
                            <span className="text-[7px] text-white mt-0 top-0">1</span><p className="w-[450px] font-hanken-grotesk md:text-[11px]  text-[13px] font-[400] text-[white]">{promoKey === PAID_PROMO_KEY ? t('comparison_para_two') : (t("comparison_para_two"))}</p>
                        </div>
                    </p>
                    <p className="relative">
    <div className="flex gap-0 items-start">
        <span className="text-[7px] text-white mt-0 top-0">2</span>
        
        <span className="font-hanken-grotesk md:text-[11px] text-[13px] font-[400] text-white">
            {(t('comparison_para_three_updated'))}
            <span className="underline cursor-pointer" onClick={handleClick}>
                https://www.kudzumoney.com/
                policies/covered-by-kudzu plus -terms.
            </span>
        </span>
    </div>
</p>


                    <p className="relative">
                        <div className="flex gap-0">
                        <span className="text-[7px] text-white mt-0 top-0">3</span> <p className="w-[463px] font-hanken-grotesk md:text-[11px] text-[13px] font-[400] text-[white]">{promoKey === PAID_PROMO_KEY ?  t('comparison_para_four') : (t("comparison_para_four"))}</p>
                        </div>
                    </p>
                    <p className="relative">
                        <div className="flex gap-0">
                        <span className="text-[7px] text-white mt-0 top-0">4</span><p className="w-[470px] font-hanken-grotesk md:text-[11px]  text-[13px] font-[400] text-[white]">{promoKey === PAID_PROMO_KEY ?  t('comparison_para_five') : (t("comparison_para_five"))}</p>
                        </div>
                    </p>
                </div>
            </div>
            {loading && <Loader />}
        </div>
    );
}

export default ComparisonOffer;
